import { CSSProperties } from 'react'
import BeatLoader from 'react-spinners/BeatLoader'

const override: CSSProperties = {
  display: 'block',
  margin: '0 auto',
  borderColor: 'blue'
}

export function LoadingComponent (): JSX.Element {
  return (
    <div className='sweet-loading'>
      <BeatLoader
        loading
        color='#092240'
        cssOverride={override}
        size={40}
        aria-label='Loading Spinner'
        data-testid='loader'
      />
    </div>
  )
}
